<style scoped lang="scss" type="text/scss">
    .wrap-container {
    }
</style>

<template>
    <div class="wrap-container global-relative">
        <div class="global-relative">
            <loading-placeholder :loading="requesting"></loading-placeholder>
            <el-table :data="players" stripe border size="small" style="width: 100%; margin-top: 1rem"
                      :max-height="visualAreaHeight" >
                <el-table-column fixed prop="iz_select" label="中期" align="center" min-width="150">
                    <template slot-scope="scope">
<!--                        <el-checkbox v-model="scope.row.iz_select" @change="checkboxChange($event, scope.row.id)"></el-checkbox>-->
                      不通过<el-switch
                          v-model="scope.row.iz_select"
                          @change="checkboxChange($event, scope.row.id)"
                          active-color="#13ce66"
                          inactive-color="#ff4949">
                      </el-switch>通过
                    </template>
                </el-table-column>
                <el-table-column fixed prop="iz_select2" label="选择" align="center" min-width="50">
                    <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.iz_select2" @change="checkboxChange2($event, scope.row.id)"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column fixed type="index" label="序号" align="center" width="80"></el-table-column>
                <el-table-column fixed prop="school_name" label="学校名称" align="center" min-width="180"></el-table-column>
                <el-table-column fixed prop="team_name" label="队伍名称" align="center" min-width="200"></el-table-column>
                <el-table-column prop="confirmed" label="状态" align="center" min-width="80" :filters="[{text: '已确认', value: '已确认'},{text: '未确认', value: '未确认'}]" :filter-method="filterTag">
                    <template slot-scope="scope">
                        <status-tag :success="true === scope.row.confirmed_boolean"
                                    positive-text="已确认" negative-text="未确认">
                        </status-tag>
                    </template>
                </el-table-column>
                <el-table-column v-for="column in columns" :key="column.prop" :prop="column.prop" :label="column.label"
                                 align="center" min-width="80">
                    <template slot-scope="scope">
                        <status-tag :success="true === scope.row.player_registration_overview[column.prop]">
                        </status-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="100">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" plain
                                   :disabled="!scope.row.confirmed_boolean"
                                   @click="cancelConfirmation(scope.row.id)"
                                   :loading="scope.row.id === cancelConfirmationRequestingId && cancelConfirmationRequesting"
                        >
                            重置状态
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import infoPanel from '../../../../../components/info-panel/index';
    import StatusTag from '../../../../../components/status-tag/index';
    import {handlePlayers} from '../../../../../utils/data-handler';
    import checkbox from "element-ui/packages/checkbox";

    export default {
        name: '',
        components: {
            infoPanel,
            StatusTag
        },
        data () {
            return {
                requesting: false,
                players: [],
                cancelConfirmationRequestingId: null,
                cancelConfirmationRequesting: false,
                columns: [
                    {
                        prop: 'contact_completed',
                        label: '联系人'
                    },
                    {
                        prop: 'narrator_completed',
                        label: '推荐解说'
                    },
                    {
                        prop: 'referee_completed',
                        label: '推荐裁判'
                    },
                    {
                        prop: 'flag_bearer_completed',
                        label: '推荐旗手'
                    },
                    {
                        prop: 'introduce_completed',
                        label: '参赛介绍'
                    },
                    {
                        prop: 'funding_completed',
                        label: '总经费'
                    },
                    {
                        prop: 'sponsorship_completed',
                        label: '赞助'
                    },
                    {
                        prop: 'robot_completed',
                        label: '机器人'
                    },
                    {
                        prop: 'consignee_completed',
                        label: '收件信息'
                    },
                    {
                        prop: 'present_completed',
                        label: '到场情况'
                    },
                    {
                        prop: 'accommodation_completed',
                        label: '住宿信息'
                    },
                    {
                        prop: 'group_photo_completed',
                        label: '合照'
                    }
                ],
            };
        },
        computed: {
            checkbox() {
                return checkbox
            },
            currentCompetitionId () {
                return this.$store.state.competition.currentCompetitionId;
            },
            visualAreaHeight () {
                return this.$store.getters['layout/adminPlayerInformationOverviewVisualAreaHeight'];
            }
        },
        watch: {
            currentCompetitionId: {
                immediate: true,
                handler (id) {
                    if (id === null || id === undefined) return;
                    this.loadPlayersWithOverviewByCompetitionId();
                }
            }
        },
        methods: {
            filterTag(value,row){
                var isShow=value=='已确认'?true:false
                return row.confirmed_boolean==isShow;
            },
            checkboxChange(izSelect, id) {
                this.$normalRequest('player/changeIzSelect', {id: id, izSelect: izSelect}
                , false, false, this, 'requesting').then(_ => {
                    this.loadPlayersWithOverviewByCompetitionId();
                });
            },
            checkboxChange2(izSelect2, id) {
                this.$normalRequest('player/changeIzSelect2', {id: id, izSelect2: izSelect2}
                , false, false, this, 'requesting').then(_ => {
                    this.loadPlayersWithOverviewByCompetitionId();
                });
            },
            loadPlayersWithOverviewByCompetitionId () {
                this.$normalRequest('player/loadPlayersWithOverviewByCompetitionId', {
                    competition_id: this.currentCompetitionId
                }, false, false, this, 'requesting').then(data => {
                    this.players = handlePlayers(data);
                });
            },
            cancelConfirmation (playerId) {
                this.$normalConfirm('确认重置该参赛队确认状态？', '重置操作无法撤回，请谨慎操作').then(_ => {
                    this.cancelConfirmationRequestingId = playerId;
                    this.$normalRequest('player/cancelConfirmation', {id: playerId}, '已完成重置操作', true, this, 'cancelConfirmationRequesting').then(_ => {
                        this.loadPlayersWithOverviewByCompetitionId();
                        this.cancelConfirmationRequestingId = null;
                    }).catch(_ => {
                        this.cancelConfirmationRequestingId = null;
                    });
                }).catch(_ => {
                });
            }
        }
    };
</script>
